import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { pendingTasksReducer } from 'react-redux-spinner'

import app from './app'
import login from './login'
import password_recovery from './password_recovery'
import email_verification from './email_verification'
import registration from './registration'
import details from './details'
import integration from './integration'
import settings from './settings'
import billing from './billing'

import sites from './sites'
import payments from './payments'
import vox_payments from './vox_payments'
import withdrawals from './withdrawals'
import pay_license from './pay_license'
import summary from './summary'
import jivo_widget from './jivo_widget';
import googleSignIn from './sign_in/google';

export default combineReducers({
  routing: routerReducer,
  pendingTasks: pendingTasksReducer,
  
  app,
  login,
  password_recovery,
  email_verification,
  registration,
  details,
  integration,
  settings,
  billing,

  sites,
  payments,
  vox_payments,
  withdrawals,
  pay_license,
  summary,
  jivo_widget,
  googleSignIn,
})



// WEBPACK FOOTER //
// ./src/ducks/index.js